import React from 'react';
import { Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { getUserData } from '../../helpers';
import { PAGE_URLS } from '../../constants';

const RedirectionAfterLogin = () => {
  const subscriptionDetails = getUserData('subscriptionDetails');
  const totalProjects = getUserData('totalProjects');
  const permissions = useSelector((state) => state.permissionsReducer);
  if (subscriptionDetails.currentPlan === 'trial' && !totalProjects) {
    return <Redirect to="/projects/create" />;
  }
  if (permissions && permissions.includes('dashboard_view')) {
    return <Redirect to={PAGE_URLS.DASHBOARD} />;
  }
  return <Redirect to={PAGE_URLS.PROJECTS.ACTIVE} />;
};

export default RedirectionAfterLogin;
